import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-free-trial-banner',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule
  ],
  templateUrl: './free-trial-banner.component.html',
  styleUrls: ['./free-trial-banner.component.scss']
})
export class FreeTrialBannerComponent {
}
